import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { price, priceIncludes } from '../data/content';
type PriceCardProps = {
  ctaLabel: string;
};
export function PriceCard({
  ctaLabel
}: PriceCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="mx-auto flex w-full max-w-2xl flex-col items-center rounded-4xl border-2 border-clay/40 bg-cream p-8 text-center shadow-xl shadow-ink/10 sm:p-10" data-id="element-89" data-mp="28qy09dsah9bi">
      <span className="text-sm font-bold uppercase tracking-[0.2em] text-clay" data-id="element-90" data-mp="2mkyq1i19jlzq">
        Precio del paquete completo
      </span>
      <p className="mt-4 font-display text-5xl font-semibold leading-none text-ink sm:text-6xl" data-id="element-91" data-mp="1b3yzaqukdf7t">
        {price.amount}
        <span className="align-top text-3xl sm:text-4xl" data-id="element-92" data-mp="1g323k92pzheq">{price.currency}</span>
      </p>
      <p className="mt-3 text-base font-semibold uppercase tracking-[0.12em] text-sage-dark" data-id="element-93" data-mp="3klkv0eo0169t">
        {price.note}
      </p>

      <ul className="mt-8 w-full space-y-3 text-left" data-id="element-94" data-mp="3fob4evovioke">
        {priceIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-95" data-mp="3tnkb94r6w6bp">
            <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-sage" strokeWidth={2.5} aria-hidden="true" data-id="element-96" data-mp="3onxw2prswg09" />
            <span className="text-lg leading-relaxed text-ink" data-id="element-97" data-mp="7dq5qnvpkm7h">{item}</span>
          </li>)}
      </ul>

      <div className="mt-9 w-full" data-id="element-98" data-mp="2edelqxt0sz3">
        <CtaButton className="w-full" data-id="element-99" data-mp="g8e6c0qc9fpy">{ctaLabel}</CtaButton>
      </div>
      <p className="mt-4 text-base text-muted" data-id="element-100" data-mp="g9peecqth9mv">
        Descarga inmediata después del pago. Este producto es digital.
      </p>
    </motion.div>;
}